/* eslint-disable no-param-reassign */
const setProps = (data, label, value) => {
  data[label] = value
  return data
}

export { setProps }
